import { Directive, Host, Injectable, Injector, Input, OnDestroy, OnInit, Self, ViewContainerRef} from '@angular/core';
import { ComponentCanDeactivate } from '../_helpers/guards/unsaved-changes.guard';
import { TabChangeService } from '../_services/shared/tab-change.service';

/**
 * @description: Directive applied to angular component hosting form for which you want to track unsaved change.
 */
@Directive({
    selector: '[wfdssDeactivationAware]',
    standalone: false
})
export class DeactivationAwareDirective implements OnInit, OnDestroy {
  /**
   * @description:Index of the tab in which the host component resides. Mandatory field.
   */
  @Input() tabIndex!: number;  
  /**
   * @description:Component where this directive is applied. This is applicable when separate angular components (wrapped within mat-tab) are used to host form
   */
  @Input() hostComponent: any;
  /**
   * @description:This is applicable when form is hosted within mat-tab without needing separate angular component
   */
  @Input() formGroup: any;
    /**
   * @description: Applies only if formGroup exists. This is to indicate if form should be marked pristing when user chooses to move on to next 
   *              tab without saving. Defaulted to 'false'.
   */
  @Input() markFormPristine: boolean = false;  
  

  constructor(private tabChangeService: TabChangeService) {}

  ngOnInit() {
    if (this.hostComponent) {
      this.tabChangeService.registerComponent(this.tabIndex, this.hostComponent);
    } else if (this.formGroup) {
      this.tabChangeService.registerFormGroup(this.tabIndex, this.formGroup, this.markFormPristine);
    }
  }

  ngOnDestroy(): void {
  // When mat-tab-group is not being used like in case of Decision Approval/Assessment, ConfirmTabChangeDirective is not being used. So, to clear cache from tabChangeService
  // ngOnDestroy in this directive would come helpful. 
    this.tabChangeService.clear();
  }

}



  


